import { action, payload } from 'ts-action'
import { IShift, IShiftApplicants } from 'models/Shift'
import { IError } from 'models/Global'
import { IFavorite } from 'models/Favorite'

interface IShiftsUpdateApplicants {
  applicants: IShiftApplicants
  shiftId: number
}

export const UpshifterShiftLoading = action(
  'UpshifterShiftLoading',
  payload<boolean>(),
)

export const UpshifterShiftButtonLoading = action(
  'UpshifterShiftButtonLoading',
  payload<boolean>(),
)
export const GetUpshifterOpenShift = action(
  'GetUpshifterOpenShift',
  payload<IShift>(),
)

export const NoActiveUpshifterShift = action('NoActiveUpshifterShift')

export const ResetUpshifterActiveShift = action('ResetUpshifterActiveShift')

export const SetActiveUpshifterShiftScreen = action(
  'SetActiveUpshifterShiftScreen',
)
export const CleanUpshifterOpenShift = action('CleanUpshifterOpenShift')

export const GetUpshifterShiftError = action(
  'GetUpshifterShiftError',
  payload<IError>(),
)

export const UpshifterShiftUpdateApplicants = action(
  'UpshifterShiftUpdateApplicants',
  payload<IShiftsUpdateApplicants>(),
)

export const UpshifterShiftFavoriteBusiness = action(
  'UpshifterShiftFavoriteBusiness',
  payload<IFavorite>(),
)
export const UpshifterShiftUnfavoriteBusiness = action(
  'UpshifterShiftUnfavoriteBusiness',
)
